import React from 'react';

const LabelInput = ({ field, label }) => {
  return (
    <div className="formulaire-dynamique-main-div form-field-group">
      <div className={`formulaire-dynamique-div ${field.texteVertical && 'formulaire-dynamique-label-wrapper'}`}>
        <span className="formulaire-dynamique-span">
          {label}
        </span>
      </div>
    </div>
  );
};

export default LabelInput;

